import { useCallback, useState } from "react";

export function useLocalStorage<T>(key: string, initialValue?: T) {
  const getStoredValue = useCallback((): T | undefined => {
    try {
      const value = window.localStorage.getItem(key);
      if (value === null) {
        return initialValue;
      }
      return JSON.parse(value) as T;
    } catch {
      return initialValue;
    }
  }, [key, initialValue]);

  const [storedValue, setStoredValue] = useState(() => getStoredValue());

  const setLocalStorageValue = useCallback(
    (value: T): boolean => {
      try {
        window.localStorage.setItem(key, JSON.stringify(value));
        setStoredValue(value);
        return true;
      } catch {
        return false;
      }
    },
    [key],
  );

  const removeLocalStorageValue = useCallback((): boolean => {
    try {
      window.localStorage.removeItem(key);
      setStoredValue(initialValue);
      return true;
    } catch {
      return false;
    }
  }, [initialValue, key]);

  return { value: storedValue, setLocalStorageValue, removeLocalStorageValue };
}
